import Shepherd from "shepherd.js";
import "shepherd.js/dist/css/shepherd.css";
import userService from "../user/user-service";
//import Steps from './tourSteps';
//import Vue from 'vue';
import { checkElement, createModal } from "./func.js";

const service = new userService();
const tour = new Shepherd.Tour({
  useModalOverlay: true,
  confirmCancel: true,
  confirmCancelMessage: "Sair do tutorial?",
  tourName: "starterTutorial",
  defaultStepOptions: {
    //Default options for Steps created through addStep. Saves you from repeating step related options each time.
    cancelIcon: {
      enabled: true,
    },
    scrollTo: true,
  },
});

let skipPermanently = false;

function getCheckBox(id, translate) {
  return `<br><label style="margin-top: 10px; display: block;">
  <input type="checkbox" id="skip-step${id}-checkbox" />
  ${translate("dontShowAgain") || "Não mostrar novamente"}
  </label>`;
}

export function createTour(translate) {
  tour.addStep({
    title: translate("welcomeTour"),
    id: 1,
    text: `${translate("tutorialStep0")}${getCheckBox(1, translate)}`,
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 1",
    id: 2,
    text: `${translate("tutorialStep1")}${getCheckBox(2, translate)}`,
    attachTo: {
      element: ".navbar",
      on: "bottom",
    },
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 2",
    id: 3,
    text: `${translate("tutorialStep2")}${getCheckBox(3, translate)}`,
    attachTo: {
      element: "#btn-sidenav",
      on: "bottom",
    },
    advanceOn: { selector: "#btn-sidenav", event: "click" }, //click event to advance tour
  });
  tour.addStep({
    title: "Passo 3",
    id: 4,
    text: `${translate("tutorialStep3")}${getCheckBox(4, translate)}`,
    attachTo: {
      element: "#sidebar",
      on: "right",
    },
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 4",
    id: 5,
    text: `${translate("tutorialStep4")}${getCheckBox(5, translate)}`,
    attachTo: {
      element: "#config-link",
      on: "top",
    },
    advanceOn: { selector: "#config-link", event: "click" },
  });
  //DEVICE/DISPOSITIVO STEPS
  tour.addStep({
    title: "Passo 5",
    id: 6,
    text: `${translate("tutorialStep5")}${getCheckBox(6, translate)}`,
    attachTo: {
      element: "#devices-link",
      on: "top",
    },
    advanceOn: { selector: "#devices-link", event: "click" },
  });
  tour.addStep({
    title: "Passo 6",
    id: 7,
    text: `${translate("tutorialStep6")}${getCheckBox(7, translate)}`,
    beforeShowPromise: () => {
      return checkElement(
        "#table-device > div.w-100 > div > div > div > button"
      ).then(() => {
        return new Promise((resolve) => setTimeout(resolve, 1000)); // Wait 300ms for layout to stabilize
      });
    },
    attachTo: {
      element: "#table-device > div.w-100 > div > div > div > button",
      on: "bottom",
    },
    advanceOn: {
      selector: "#table-device > div.w-100 > div > div > div > button",
      event: "click",
    },
  });
  tour.addStep({
    title: "Passo 7",
    id: 8,
    text: `${translate("tutorialStep7")}${getCheckBox(8, translate)}`,
    beforeShowPromise: () => {
      return checkElement("#serialNumberInput");
    },
    attachTo: {
      element: "#serialNumberInput",
      on: "bottom",
    },
    //usar click para testes
    advanceOn: { selector: "#serialNumberInput", event: "click" },
  });
  tour.addStep({
    title: "Passo 8",
    id: 9,
    text: `${translate("tutorialStep8")}${getCheckBox(9, translate)}`,
    beforeShowPromise: () => {
      return checkElement("#infoModal___BV_modal_content_");
    },
    attachTo: {
      element: "#infoModal___BV_modal_content_",
      on: "bottom",
    },
    when: {
      show: function () {
        const step = this; // `this` refers to the step

        const observer = new MutationObserver(() => {
          const el = document.querySelector("#infoModal___BV_modal_content_");
          if (!el) {
            observer.disconnect();
            tour.next();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        // Store reference for cleanup
        step._observer = observer;
      },

      hide: function () {
        if (this._observer) {
          this._observer.disconnect();
          delete this._observer;
        }
      },

      cancel: function () {
        if (this._observer) {
          this._observer.disconnect();
          delete this._observer;
        }
      },
    },
  });
  tour.addStep({
    title: "Passo 9",
    id: 10,
    text: `${translate("tutorialStep9")}${getCheckBox(10, translate)}`,
    attachTo: { element: "#btn-sidenav", on: "right" },
    advanceOn: { selector: "#btn-sidenav", event: "click" },
  });
  //--------- VARIABLES STEPS
  tour.addStep({
    title: "Passo 10",
    id: 11,
    text: `${translate("tutorialStep4")}${getCheckBox(11, translate)}`,
    attachTo: {
      element: "#config-link",
      on: "top",
    },
    advanceOn: { selector: "#config-link", event: "click" },
  });
  tour.addStep({
    title: "Passo 11",
    id: 12,
    text: `${translate("tutorialStep10")}${getCheckBox(12, translate)}`,
    attachTo: { element: "#variables-link", on: "right" },
    advanceOn: { selector: "#variables-link", event: "click" },
  });
  tour.addStep({
    title: "Passo 12",
    id: 13,
    text: `${translate("tutorialStep11")}${getCheckBox(13, translate)}`,
    beforeShowPromise: () => {
      return checkElement(
        "#table-variable > div.w-100 > div > div > div > button"
      );
    },
    attachTo: {
      element: "#table-variable > div.w-100 > div > div > div > button",
      on: "bottom",
    },
    advanceOn: {
      selector: "#table-variable > div.w-100 > div > div > div > button",
      event: "click",
    },
  });
  ///explicar mask, mult, const, amostra e unidade
  tour.addStep({
    title: "Passo 13",
    id: 14,
    text: `${translate("tutorialStep12")}${getCheckBox(14, translate)}`,
    beforeShowPromise: () => {
      return checkElement("#maskInput");
    },
    attachTo: { element: "#maskInput", on: "top" },
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 14",
    id: 15,
    text: `${translate("tutorialStep13")}${getCheckBox(15, translate)}`,
    beforeShowPromise: () => {
      return createModal();
    },
    attachTo: { element: "#multiplierInput", on: "bottom" },
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 15",
    id: 16,
    text: `${translate("tutorialStep14")}${getCheckBox(16, translate)}`,
    attachTo: { element: "#constantInput", on: "top" },
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 16",
    id: 17,
    text: `${translate("tutorialStep15")}${getCheckBox(17, translate)}`,
    attachTo: { element: "#meanInput", on: "top" },
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 17",
    id: 18,
    text: `${translate("tutorialStep16")}${getCheckBox(18, translate)}`,
    beforeShowPromise: () => {
      return checkElement("#moduleInput");
    },
    attachTo: { element: "#moduleInput", on: "top" },
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 18",
    id: 19,
    text: `${translate("tutorialStep17")}${getCheckBox(19, translate)}`,
    beforeShowPromise: () => {
      return checkElement("#variableInput");
    },
    attachTo: { element: "#variableInput", on: "top" },
    buttons: [
      {
        text: translate("next"),
        action: tour.next,
      },
    ],
  });
  tour.addStep({
    title: "Passo 19",
    id: 20,
    text: `${translate("tutorialStep18")}${getCheckBox(20, translate)}`,
    beforeShowPromise: () => {
      return checkElement("#infoModal___BV_modal_content_");
    },
    attachTo: {
      element: "#infoModal___BV_modal_content_",
      on: "bottom",
    },
    when: {
      show: function () {
        const step = this; // `this` refers to the step

        const observer = new MutationObserver(() => {
          const el = document.querySelector("#infoModal___BV_modal_content_");
          if (!el) {
            observer.disconnect();
            tour.next();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        // Store reference for cleanup
        step._observer = observer;
      },

      hide: function () {
        if (this._observer) {
          this._observer.disconnect();
          delete this._observer;
        }
      },

      cancel: function () {
        if (this._observer) {
          this._observer.disconnect();
          delete this._observer;
        }
      },
    },
  });
  //tour.addStep({
  //  title: "Passo 20",
  //  id: 20,
  //  text: `${translate("tutorialStep20")}${checkboxHtml}`,
  //  attachTo: {
  //    element: "#btn-sidenav",
  //    on: "right",
  //  },
  //  advanceOn: { selector: "#btn-sidenav", event: "click" },
  //});

  //--------- DISPLAY STEPS
  //tour.addStep({
  //  title: "Passo 21",
  //  id: 21,
  //  text: translate("tutorialStep9"),
  //  attachTo: { element: "#btn-sidenav", on: "right" },
  //  advanceOn: { selector: "#btn-sidenav", event: "click" },
  //});
  //tour.addStep({
  //  title: "Passo 22",
  //  id: 22,
  //  text: translate("tutorialStep4"),
  //  attachTo: {
  //    element: "#config-link",
  //    on: "top",
  //  },
  //  advanceOn: { selector: "#config-link", event: "click" },
  //});
  //tour.addStep({
  //  title: "Passo 23",
  //  id: 23,
  //  text: translate("tutorialStep21"),
  //  beforeShowPromise: () => {
  //    return checkElement("#display-link");
  //  },
  //  attachTo: {
  //    element: "#display-link",
  //    on: "top",
  //  },
  //  advanceOn: { selector: "#display-link", event: "click" },
  //});
  //tour.addStep({
  //  title: "Passo 24",
  //  id: 24,
  //  text: translate("tutorialStep22"),
  //  beforeShowPromise: () => {
  //    return checkElement("#table > div.w-100 > div > div > div > button").then(() => {
  //      return new Promise((resolve) => setTimeout(resolve, 1000)); // Wait 300ms for layout to stabilize
  //    });
  //  },
  //  attachTo: {
  //    element: "#table > div.w-100 > div > div > div > button",
  //    on: "bottom",
  //  },
  //  advanceOn: {
  //    selector: "#table > div.w-100 > div > div > div > button",
  //    event: "click",
  //  },
  //});
  //tour.addStep({
  //  title: "Passo 25",
  //  id: 25,
  //  text: translate("tutorialStep23"),
  //  attachTo: {
  //    element: "#nameInput",
  //    on: "top",
  //  },
  //  buttons: [
  //    {
  //      text: translate("next"),
  //      action: tour.next,
  //    },
  //  ],
  //});
  //tour.addStep({
  //  title: "Passo 26",
  //  id: 26,
  //  text: translate("tutorialStep24"),
  //  attachTo: {
  //    element: "#typeInput",
  //    on: "right",
  //  },
  //  buttons: [
  //    {
  //      text: translate("next"),
  //      action: tour.next,
  //    },
  //  ],
  //});
  //tour.addStep({
  //  title: "Passo 27",
  //  id: 27,
  //  text: translate("tutorialStep25"),
  //  attachTo: {
  //    element: "#minInput",
  //    on: "right",
  //  },
  //  buttons: [
  //    {
  //      text: translate("next"),
  //      action: tour.next,
  //    },
  //  ],
  //});
  //tour.addStep({
  //  title: "Passo 28",
  //  id: 28,
  //  text: translate("tutorialStep26"),
  //  attachTo: {
  //    element: "#maxInput",
  //    on: "right",
  //  },
  //  buttons: [
  //    {
  //      text: translate("next"),
  //      action: tour.next,
  //    },
  //  ],
  //});
  //tour.addStep({
  //  title: "Passo 29",
  //  id: 29,
  //  text: translate("tutorialStep27"),
  //  // Avançar esse passo apos salvar o modelo criado - interceptor
  //  extraHighlights: ["#infoModal"],
  //  attachTo: {
  //    element: "#btn-grid > div.btn.upload",
  //    on: "right",
  //  },
  //  advanceOn: { selector: "#btn-grid > div.btn.upload", event: "click" },
  //});
  //
  ////-----------------------------------------------------------
  //tour.addStep({
  //  title: "Passo 29",
  //  id: 29,
  //  text: translate("tutorialStep28"),
  //  beforeShowPromise: () => {
  //    return checkElement("#search-table");
  //  },
  //  attachTo: {
  //    element: "#search-table",
  //    on: "right",
  //  },
  //  buttons: [
  //    {
  //      text: translate("next"),
  //      action: tour.next,
  //    },
  //  ],
  //});
  //tour.addStep({
  //  title: "Passo 30",
  //  id: 30,
  //  text: translate("tutorialStep29"),
  //  beforeShowPromise: () => {
  //    return checkElement("#table > div.table-responsive");
  //  },
  //  when: {
  //    show: () => {
  //      const arrow = document.querySelector(".shepherd-arrow");
  //      if (arrow) {
  //        arrow.style.left = "350px";
  //      }
  //    },
  //  },
  //  attachTo: {
  //    element: "#table > div.table-responsive",
  //    on: "top-end",
  //  },
  //  advanceOn: { selector: "#table > div.table-responsive", event: "click" },
  //});
  //tour.addStep({
  //  title: "Passo 31",
  //  id: 31,
  //  text: translate("tutorialStep30"),
  //  beforeShowPromise: () => {
  //    return checkElement("#infoModal___BV_modal_content_");
  //  },
  //  attachTo: {
  //    element:
  //      "#infoModal___BV_modal_body_ > div > form > div.w-100.btnGroup > div > div.relationItem",
  //    on: "top",
  //  },
  //  advanceOn: {
  //    selector:
  //      "#infoModal___BV_modal_body_ > div > form > div.w-100.btnGroup > div > div.relationItem",
  //    event: "click",
  //  },
  //});
  //tour.addStep({
  //  title: "Passo 32",
  //  id: 32,
  //  text: translate("tutorialStep31"),
  //  beforeShowPromise: () => {
  //    return checkElement(
  //      "#colorConfigTable > div.w-100 > div > div > div > button"
  //    );
  //  },
  //  attachTo: {
  //    element: "#colorConfigTable > div.w-100 > div > div > div > button",
  //    on: "top",
  //  },
  //  advanceOn: {
  //    selector: "#colorConfigTable > div.w-100 > div > div > div > button",
  //    event: "click",
  //  },
  //});
  //tour.addStep({
  //  title: "Passo 33",
  //  id: 33,
  //  text: translate("tutorialStep32"),
  //  extraHighlights: ["#minInput"],
  //  canClickTarget: false,
  //  attachTo: {
  //    element: "#maxInput",
  //    on: "right",
  //  },
  //  buttons: [
  //    {
  //      text: translate("next"),
  //      action: tour.next,
  //    },
  //  ],
  //});
  //tour.addStep({
  //  title: "Passo 34",
  //  id: 34,
  //  text: translate("tutorialStep33"),
  //  extraHighlights: ["#startInput, #endInput"],
  //  attachTo: {
  //    element: "#textInput",
  //    on: "bottom-start",
  //  },
  //  buttons: [
  //    {
  //      text: translate("next"),
  //      action: tour.next,
  //    },
  //  ],
  //});
  //tour.addStep({
  //  title: "Passo 35",
  //  id: 35,
  //  text: translate("tutorialStep34"),
  //  attachTo: {
  //    element:
  //      "#new-form > div > div > form > div.config > div.control.d-flex.flex-column.align-items-start > input",
  //    on: "top",
  //  },
  //  advanceOn: {
  //    selector:
  //      "#new-form > div > div > form > div.config > div.control.d-flex.flex-column.align-items-start > input",
  //    event: "click",
  //  },
  //});
  //tour.addStep({
  //  title: "Passo 36",
  //  id: 36,
  //  text: translate("tutorialStep35"),
  //  attachTo: {
  //    element: "#new-form > div",
  //    on: "top",
  //  },
  //});

  tour.on("show", () => {
    const currentStep = tour.getCurrentStep();
    if (currentStep.id > 0) {

      requestAnimationFrame(() => {
        const checkbox = document.querySelector(`#skip-step${currentStep.id}-checkbox`);
        if (checkbox) {
          checkbox.addEventListener(
            "change",
            () => {
              skipPermanently = checkbox.checked;
            }
          );
        }
      });

      service.updateStep((currentStep.id - 1));
    }
  });

  tour.on("cancel", () => {
    if (skipPermanently) {
      service.updateStep(-1);
    }
  });

  tour.on("complete", () => {
    console.log("complete");
    service.updateStep(-1);
  });

  service.getStep().then((data) => {
    if (data.value >= 0 && data.value <= 20) {
      console.log(data.value)
      tour.show(data.value);
    }
  });
}
